import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    ResponsiveContainer,
    Legend,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid
} from "recharts";

const COLORS = {
    "came on time": "#16a34a",
    "late": "#f59e0b",
    "left early": "#dc2626",
    "left on time": "#2563eb",
    "absent": "#6b7280"
};

export default function UserCharts({ pieData, lineData }) {

    /* =======================
       PIE FORMAT
    ======================== */
    const pieFormatted =
        pieData?.labels?.map((label, i) => ({
            name: label,
            value: pieData.data[i]
        })) || [];

    const total =
        pieFormatted.reduce((acc, cur) => acc + cur.value, 0);

    /* =======================
       LINE FORMAT
    ======================== */
    const lineFormatted =
        lineData?.labels?.map((date, i) => {
            const row = { date };

            lineData.datasets.forEach(ds => {
                row[ds.label] = ds.data[i];
            });

            return row;
        }) || [];

    return (
        <div className="charts-wrapper">

            {/* ================= PIE ================= */}
            <div className="chart-card">
                <h4>Status Distribution</h4>

                <ResponsiveContainer width="100%" height={320}>
                    <PieChart>
                        <Pie
                            data={pieFormatted}
                            dataKey="value"
                            nameKey="name"
                            innerRadius={70}
                            outerRadius={110}
                            paddingAngle={4}
                            label={({ percent }) =>
                                `${(percent * 100).toFixed(0)}%`
                            }
                            isAnimationActive
                        >
                            {pieFormatted.map((entry, index) => (
                                <Cell
                                    key={index}
                                    fill={
                                        COLORS[entry.name] ||
                                        "#9ca3af"
                                    }
                                />
                            ))}
                        </Pie>

                        <Tooltip />
                        <Legend verticalAlign="bottom" />
                    </PieChart>
                </ResponsiveContainer>

                {/* Center total */}
                <div className="pie-center">
                    <h2>{total}</h2>
                    <span>Total</span>
                </div>
            </div>

            {/* ================= LINE ================= */}
            <div className="chart-card">
                <h4>Attendance Trend</h4>

                <ResponsiveContainer width="100%" height={350}>
                    <LineChart
                        data={lineFormatted}
                        margin={{
                            top: 10,
                            right: 20,
                            left: 0,
                            bottom: 10
                        }}
                    >
                        <CartesianGrid
                            strokeDasharray="3 3"
                            opacity={0.2}
                        />

                        <XAxis
                            dataKey="date"
                            tick={{ fontSize: 12 }}
                        />

                        <YAxis allowDecimals={false} />

                        <Tooltip />

                        {lineData?.datasets?.map((ds, index) => (
                            <Line
                                key={index}
                                type="monotone"
                                dataKey={ds.label}
                                stroke={
                                    COLORS[ds.label] ||
                                    "#9ca3af"
                                }
                                strokeWidth={3}
                                dot={{ r: 4 }}
                                activeDot={{ r: 6 }}
                                animationDuration={800}
                            />
                        ))}
                    </LineChart>
                </ResponsiveContainer>
            </div>

        </div>
    );
}
